<template>
    <!-- <div style="position: relative;height: 100%;align-items: center;" class="flex_center mr_5">
        <i class="iconfont icon-douyin" style="color: #000;"></i> -->
    <!-- <i class="iconfont icon-kuaishou11 m_color_kuaishou"></i>  -->
    <!-- <i class="iconfont icon-xiaohongshu m_color_e1"></i>-->
    <!-- <img src="@assets/adicon/tencent.png" style="width:20px;height: 20px;" /> -->
    <!-- <img src="@assets/adicon/baidu.png" style="width:18px;height: 18px;" />
        <i class="iconfont icon-zhinengwangyehuise m_color_webh5"></i> -->
    <!-- </div> -->

    <div style="width: 100%;height: 66px;overflow: hidden;box-sizing: border-box;">
        <div class="top" style="align-items: center;">
            <div style="display: flex;align-items: center;height: 15px;">
                <i v-if="item.plat_type == 1" class="iconfont icon-douyin" style="color: #000;"></i>
                <i v-else-if="item.plat_type == 2" class="iconfont icon-xiaohongshu m_color_e1"></i>
                <div v-else-if="item.plat_type == 3">
                    <img src="@assets/adicon/tencent.png" v-if="item.account_type == 36"
                        style="width:15px;height: 15px;object-fit: fill;" />
                    <img src="@assets/adicon/baidu.png" v-else-if="item.account_type == 37"
                        style="width:15px;height: 15px;object-fit: fill;position: relative;top:2px;" />
                    <i class="iconfont icon-zhinengwangyehuise m_color_webh5" v-else></i>
                </div>
                <i v-else-if="item.plat_type == 9" class="iconfont icon-weixinxiaodian m_color_wxstore"></i>
                <i v-else-if="item.plat_type == 4" class="iconfont icon-wechat1 m_color_wechat"></i>
                <i v-else-if="item.plat_type == 5" class="iconfont icon-kuaishou11 m_color_kuaishou"></i>
                <i v-else-if="item.plat_type == 10" class="iconfont icon-douyinlaike m_color_laikeim"></i>
                <i v-else-if="item.plat_type == 12" class="iconfont icon-shipinhao m_color_shipinhao"></i>
            </div>
            <div class="ml_5" style="font-weight: bold;color:rgba(0,0,0,.5)">
                {{ item.account_nickname }}
            </div>
            <div class="m_border_r m_desc overflow_ellipsis" style="margin-left: 3px; font-size: 11px; padding: 0 3px">
                {{
                    $syscfgNameByValue("customer_type_list", item.customer_type_id)
                }}
            </div>
        </div>
        <div class="flex_center bottom" style="align-items: center;">
            <!-- <div class="flex_center">

                <div v-if="item.avatar" style="position: relative;">
                    <div class="account_img_container">
                        <img :src="item.account_avatar" />
                    </div>
                </div>
            </div> -->

            <div class="friend_item_container">
                <div v-if="item.avatar" style="position: relative;">
                    <div class="friend_img_container">
                        <img :src="item.avatar" />
                    </div>
                    <em v-if="item.new_msg_count && item.cid != selectedAccountFriendId" class="friend_vui__badge">{{
                        item.new_msg_count }}</em>
                </div>
                <div class="info flex1 friend_item">
                    <div class="r1 flex1">
                        <div>
                            <el-tooltip class="box-item" effect="dark" :content="handleGetArtificialTipMsg(item)"
                                placement="top">
                                <div>
                                    <i v-if="item.is_artificial === 1"
                                        class="iconfont icon-male m_desc_color m_color_s22"
                                        style="margin-right: 2px;"></i>
                                </div>
                            </el-tooltip>
                        </div>

                        <h2 class="title r1_l ">
                            <span class="m_color_2"> {{ item.title || "--" }}</span>
                        </h2>
                        <div class="time flex-selft r1_r">{{ handleDateTimeFormat(item.time) }}</div>
                    </div>
                    <div class="r2">
                        <div class="r2_m">
                            <span v-if="item.have_customer_flg > 0">
                                <el-tooltip class="box-item" effect="dark"
                                    :content="item.save_customer_flg == 1 ? '线索已保存' : '线索未保存'" placement="top">
                                    <span>
                                        <el-tag v-if="item.save_customer_flg == 1" size="small" class="m_friend_icon"
                                            style="margin-right: 2px;">线索</el-tag>
                                        <el-tag v-else type="warning" size="small" class="m_friend_icon"
                                            style="margin-right: 2px;">线索</el-tag>
                                    </span>
                                </el-tooltip>
                            </span>

                            <span v-else>
                                <el-tooltip class="box-item" effect="dark" :content="handleSpeakStr(item.is_interact)"
                                    placement="top">
                                    <span>
                                        <i class="iconfont icon-shuohuaspeak1 speack_icon m_friend_icon"
                                            v-if="item.is_interact == 1"></i>
                                        <i class="iconfont icon-shuohuaspeak nospeack_icon m_friend_icon" v-else></i>
                                    </span>
                                </el-tooltip>
                            </span>
                            <span v-if="item.employee_not_reply_flg == 1">
                                <el-tag size="small" class="m_friend_icon" type="danger"
                                    style="margin:0 2px;">未回</el-tag>
                            </span>
                            <img v-if="item.comment_num > 0" :src="require('@assets/img/comment.png')" class="btn"
                                style="width:15px;height: 15px;" title="有评论消息" />
                            <div style="flex:1;width:1px;margin-left: 2px;" class="overflow_ellipsis">
                                {{ item.subtit || "--" }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { reactive, toRefs, inject, computed, onMounted, ref, watch, onUnmounted } from "vue";
import { useStore } from "vuex";
export default {

    props: {
        item: {
            type: Object,
            default: () => {
                return {}
            },
        }
    },
    setup(props) {
        let store = useStore();
        const momentUtil = inject("momentUtil");
        const selectedAccountFriendId = inject('selectedAccountFriendId')
        //好友人工接管提示信息
        const handleGetArtificialTipMsg = (item) => {
            let msg = ""

            let AiMsg = "Ai消息(如果AI启用)，"
            //后台AI接管开启
            // if(chatingAccount.value.use_robot_status === 1){
            //   AiMsg = ""
            // }

            //人工接管开启
            if (item.is_artificial == 1) {
                msg = `人工接管状态【开启】：${AiMsg}追粉消息和欢迎语【不会发送】`
            } else {
                msg = `人工接管状态【关闭】：${AiMsg}追粉消息和欢迎语【正常发送】`
            }
            return msg
        }
        const handleSpeakStr = (is_interact) => {
            return is_interact == 1 ? "已开口" : "未开口"
        }
        const handleDateTimeFormat = (dateStr) => {
            if (!dateStr) {
                return '';
            }
            let timeMoment = momentUtil.moment(dateStr, "YYYY-MM-DD HH:mm:ss")
            if (timeMoment.isSame(momentUtil.moment(), "day")) {
                return timeMoment.format('HH:mm')
            }
            return timeMoment.fromNow();
        }
        return {
            selectedAccountFriendId,
            handleGetArtificialTipMsg,
            handleSpeakStr,
            handleDateTimeFormat
        }
    }
}
</script>

<style lang="scss" scoped>
.top {
    height: 20px;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    align-items: center;
}

.bottom {
    height: 45px;
    overflow: hidden;
    box-sizing: border-box;
}

.friend_item_container {
    display: flex;
    width: 100%;
    align-items: center;
}

.friend_vui__badge {
    position: absolute;
    top: -5px;
    right: -5px;
}

.account_img_container {
    box-sizing: border-box;
    position: relative;
    width: 35px;
    height: 35px;
    border-radius: 10px;
    overflow: hidden;

    img {
        margin-right: 10px;
        height: 35px;
        width: 35px;
        flex-shrink: 0;
        position: relative
    }
}

.friend_img_container {
    box-sizing: border-box;
    position: relative;
    width: 35px;
    height: 35px;
    border-radius: 100%;
    overflow: hidden;

    img {
        margin-right: 10px;
        height: 35px;
        width: 35px;
        flex-shrink: 0;
        position: relative
    }
}


.friend_item {
    box-sizing: border-box;
    margin-left: 5px;

    .r1 {
        white-space: nowrap;
        text-overflow: ellipsis;
        box-sizing: border-box;
        display: flex;

        .title {
            font-size: 14px;
        }

        .r1_l {
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            word-break: break-all;
            // width: 130px;
            box-sizing: border-box;
        }

        .r1_r {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            word-break: break-all;
            width: 60px;
            text-align: right;
        }

        .time {
            color: #bbb;
            font-size: 12px;
            font-family: arial;
            margin-top: 3px;
            text-align: right;
            min-width: 35px
        }
    }

    .r2 {
        // margin-top: 5px;
        white-space: nowrap;
        box-sizing: border-box;

        .r2_m {
            display: flex;
            align-items: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            word-break: break-all;
            color: #9ea0a3;
            font-size: 12px;

            .speack_icon {
                color: rgb(0, 139, 139);
            }

            .nospeack_icon {
                color: #9ea0a3;
            }

            .pr {
                flex: 1;
                width: 1px;
            }
        }
    }
}
</style>